/* YAMU CRO: Complete Your Look (cross-sell bundle) */
(function () {
  'use strict';

  // ---- money formatting (Shopify money_format aware) ----
  var FORMAT = window.YamuCLMoneyFormat || '${{amount}}';
  function formatMoney(cents) {
    cents = Number(cents) || 0;
    function num(n, decimals, thousands, decimalSep) {
      decimals = decimals == null ? 2 : decimals;
      thousands = thousands == null ? ',' : thousands;
      decimalSep = decimalSep == null ? '.' : decimalSep;
      var value = (cents / 100).toFixed(decimals);
      var parts = value.split('.');
      var dollars = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      var rest = parts[1] ? decimalSep + parts[1] : '';
      return dollars + rest;
    }
    return FORMAT.replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, token) {
      switch (token) {
        case 'amount': return num(2, ',', '.');
        case 'amount_no_decimals': return num(0, ',', '.');
        case 'amount_with_comma_separator': return num(2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return num(0, '.', ',');
        case 'amount_with_space_separator': return num(2, ' ', ',');
        default: return num(2, ',', '.');
      }
    });
  }

  function variantFor(item) {
    var el = item.querySelector('[data-cl-variant]');
    if (!el) return null;
    var id, price;
    if (el.tagName === 'SELECT') {
      var opt = el.options[el.selectedIndex];
      id = el.value;
      price = opt ? opt.getAttribute('data-price') : null;
    } else {
      id = el.value;
      price = el.getAttribute('data-price');
    }
    return { id: Number(id), price: Number(price) || 0 };
  }

  function initRoot(root) {
    if (root.dataset.clInit === 'true') return;
    root.dataset.clInit = 'true';

    var pct = Number(root.getAttribute('data-discount')) || 0;
    var discountCode = (root.getAttribute('data-discount-code') || '').trim();
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-cl-item]'));
    var wasEl = root.querySelector('[data-cl-was]');
    var nowEl = root.querySelector('[data-cl-now]');
    var saveEl = root.querySelector('[data-cl-save]');
    var countEl = root.querySelector('[data-cl-count]');
    var btn = root.querySelector('[data-cl-add]');
    var msg = root.querySelector('[data-cl-msg]');
    var adding = false;

    function isChecked(item) { return item.classList.contains('is-checked'); }

    function selected() {
      return items.filter(isChecked).map(function (item) {
        return { item: item, variant: variantFor(item) };
      }).filter(function (x) { return x.variant && x.variant.id; });
    }

    function recompute() {
      var sel = selected();
      var subtotal = sel.reduce(function (sum, x) { return sum + x.variant.price; }, 0);
      var count = sel.length;
      var bundleActive = count >= 2 && pct > 0;
      var discounted = bundleActive ? Math.round(subtotal * (1 - pct / 100)) : subtotal;

      countEl.textContent = 'Bundle total (' + count + ' item' + (count === 1 ? '' : 's') + ')';
      nowEl.textContent = formatMoney(discounted);

      if (bundleActive) {
        wasEl.textContent = formatMoney(subtotal);
        wasEl.hidden = false;
        saveEl.textContent = 'You save ' + formatMoney(subtotal - discounted) + ' (' + pct + '%) on this bundle';
        saveEl.hidden = false;
      } else {
        wasEl.hidden = true;
        saveEl.hidden = true;
      }

      btn.disabled = count < 1;
      btn.textContent = count <= 1
        ? 'Add to cart'
        : 'Add ' + count + ' items to cart' + (bundleActive ? ' & save ' + formatMoney(subtotal - discounted) : '');
    }

    // per-item variant price label
    function refreshItemPrice(item) {
      var v = variantFor(item);
      var priceEl = item.querySelector('[data-cl-price]');
      if (v && priceEl) priceEl.textContent = formatMoney(v.price);
    }

    root.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-cl-toggle]');
      if (!toggle) return;
      var item = toggle.closest('[data-cl-item]');
      if (!item) return;
      if (toggle.hasAttribute('data-cl-locked')) return; // current product stays in
      var on = !item.classList.contains('is-checked');
      item.classList.toggle('is-checked', on);
      toggle.setAttribute('aria-pressed', on ? 'true' : 'false');
      recompute();
    });

    root.addEventListener('change', function (e) {
      var sel = e.target.closest('[data-cl-variant]');
      if (!sel) return;
      refreshItemPrice(sel.closest('[data-cl-item]'));
      recompute();
    });

    function openCart() {
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
      var toggle = document.querySelector('[data-cart-toggle]')
        || document.querySelector('cart-drawer-opener button')
        || document.querySelector('a[href$="/cart"]');
      if (toggle && typeof toggle.click === 'function') {
        setTimeout(function () { toggle.click(); }, 150);
      }
    }

    function add() {
      if (adding) return;
      var sel = selected();
      if (!sel.length) return;
      var bundleId = 'cl-' + new Date().getTime();
      var bundle = sel.length >= 2;
      var payload = sel.map(function (x) {
        var line = { id: x.variant.id, quantity: 1 };
        if (bundle) {
          line.properties = { _bundle_id: bundleId, _bundle: 'Complete Your Look' };
        }
        return line;
      });

      adding = true;
      btn.disabled = true;
      btn.textContent = 'Adding...';
      msg.className = 'yamu-cl__msg';
      msg.textContent = '';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: payload })
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (d) { throw new Error(d.description || 'Could not add to cart.'); });
          return r.json();
        })
        .then(function () {
          // Apply the bundle discount code so the saving shown above is the
          // saving actually charged. Only for real bundles (2+ items) where a
          // code is configured in Theme settings > YAMU Complete Your Look.
          // /cart/update.js replaces the ENTIRE discount set, so merge with any
          // codes already on the cart (e.g. Auto-Apply Discounts) rather than
          // overwriting them.
          if (!bundle || !discountCode || pct <= 0) return null;
          return fetch('/cart.js', { headers: { Accept: 'application/json' } })
            .then(function (r) { return r.ok ? r.json() : null; })
            .then(function (cart) {
              var codes = ((cart && cart.discount_codes) || [])
                .filter(function (d) { return d && d.applicable && d.code; })
                .map(function (d) { return d.code; });
              var seen = {};
              var merged = codes.concat([discountCode]).filter(function (c) {
                var k = c.toUpperCase();
                if (seen[k]) return false;
                seen[k] = true;
                return true;
              });
              return fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({ discount: merged.join(',') })
              });
            })
            .catch(function () { return null; });
        })
        .then(function () {
          msg.textContent = bundle ? 'Bundle added to cart.' : 'Added to cart.';
          msg.className = 'yamu-cl__msg is-success';
          openCart();
        })
        .catch(function (err) {
          msg.textContent = err.message || 'Could not add to cart. A size may be sold out.';
          msg.className = 'yamu-cl__msg is-error';
        })
        .finally(function () {
          adding = false;
          recompute();
        });
    }

    btn.addEventListener('click', add);
    recompute();
  }

  function init() {
    document.querySelectorAll('[data-yamu-cl]').forEach(initRoot);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // re-init if the section is re-rendered in the theme editor
  document.addEventListener('shopify:section:load', init);
})();
